module.exports = __webpack_public_path__ + "static/img/payBg.cef8587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/payBg.png
// module id = 39D3
// module chunks = 1